import translation from 'locales/translation';
import UnauthorizedScreen from 'pages/Errors/UnauthorizedScreen/UnauthorizedScreen';

export interface IUserRolwUnauthorizedScreen {
  label?: string;
  toLogout: Function;
}

export default function UserRoleUnauthorizedScreen({
  label,
  toLogout,
}: IUserRolwUnauthorizedScreen) {
  return (
    <UnauthorizedScreen
      label={label || translation.UserRoleUnauthorizedScreen.label}
      callback={() => toLogout()}
      callbackLabel={translation.UserRoleUnauthorizedScreen.logoutButton}
    />
  );
}
